/** @jsxImportSource @emotion/react */

import { Fragment } from 'react';
import { CSSObject, keyframes } from '@emotion/react';
import useTheme from '../../../hooks/useTheme';

interface IInputValidationError
  extends React.InputHTMLAttributes<HTMLDivElement> {
  inputId: string;
  message?: string;
}

const InputValidationError = ({
  inputId,
  message,
  ...props
}: IInputValidationError) => {
  const { color } = useTheme();

  const fadeInAnimation = keyframes`
    0% {
      opacity: 0;
      max-height: 0;
    }
    100% {
      opacity: 1;
      max-height: 100px;
    }
  `;

  const STYLE: CSSObject = {
    color: color.ALERT,
    marginTop: 3,
    fontSize: '13px',
    animation: `${fadeInAnimation} 0.3s forwards`,
  };

  return (
    <Fragment>
      {message && (
        <span
          id={`${inputId}-validation-error`}
          css={STYLE}
          {...props}
          aria-live='polite'
        >
          {message}
        </span>
      )}
    </Fragment>
  );
};

export default InputValidationError;
